import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import { Route, Switch } from 'react-router-dom';
import LayoutContainer from '../../containers/Layout';
import SuccessDialog from '../../components/SuccessDialog';
import ErrorDialog from '../../components/ErrorDialog';

//- Pages / Route
import CarrierConfirmation from './CarrierConfirmation';
import SubmitSupplierLoadingNumbers from './SubmitSupplierLoadingNumbers';
import pfLogo from '../../images/pearsonFuelsLogoV2.png';
import BulkCarrierConfirmation from './BulkCarrierConfirmation';
import BulkSupplierConfirmation from './BulkSupplierConfirmation';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import SubmitMultiSitePricing from './SubmitMultiSitePricing';

const styles = (theme) => {
	const primaryColor = theme.palette.primary[500];
	return {
		root: {
			width: '100%',
			height: 'auto',
			zIndex: 1,
			overflow: 'hidden',
			backgroundColor: '#e5e5e6',
		},
		container: {
			maxWidth: 1024,
			width: '100%',
		},
		header: {
			width: '100%',
			position: 'relative',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			height: 54,
			backgroundColor: 'white',
		},
		headerStrip: {
			backgroundColor: primaryColor,
			height: 4,
		},
		headerInside: {
			display: 'flex',
			justifyContent: 'space-between',
			padding: theme.spacing(1),
			boxSizing: 'border-box',
			[theme.breakpoints.up('md')]: {
				padding: theme.spacing(3),
				height: 'calc(100% - 64px)',
			},
		},
		logo: {
			height: 24,
			width: 155,
		},
		headerTitle: {
			color: '#777777',
			fontSize: 14,
			textAlign: 'right',
			lineHeight: 1.4,
		},
		main: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		content: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			width: '100%',
			maxWidth: 1024,
			height: 'calc(100% - 56px)',
			paddingTop: theme.spacing(2),
			padding: theme.spacing(1),
			boxSizing: 'border-box',
			[theme.breakpoints.up('md')]: {
				padding: theme.spacing(3),
				height: 'calc(100% - 64px)',
			},
		},
		hide: {
			display: 'none',
		},
	};
};

const NoMatch = () => (
	<div>
		<h2>Invalid URL. Please check your URL or contact marketing@pearsonfuels.com</h2>
	</div>
);

class Layout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isSuccessDialogOpen: false,
			isErrorDialogOpen: false,
		};
		this.handleSuccessClose = this.handleSuccessClose.bind(this);
	}

	handleSuccessClose() {
		this.props.clearSuccess();
		this.props.history.push(this.props.onSuccessRedirectTo);
	}

	render() {
		const { classes, successMessages = [], errorMessages = [] } = this.props;

		const isSuccessDialogOpen = successMessages.length !== 0;
		const isErrorDialogOpen = errorMessages.length !== 0;

		return (
			<div className={classes.root}>
				<div className={classes.header}>
					<div className={classes.container}>
						<div className={classes.headerInside}>
							<img alt="Logo" className={classes.logo} src={pfLogo} />
							<div className={classes.headerTitle}>FUEL MANAGEMENT PLATFORM</div>
						</div>
					</div>
				</div>
				<div className={classes.headerStrip} />
				<div className={classes.main}>
					<div className={classes.container}>
						<main className={classes.content}>
							<Switch>
								<Route exact path="/sms/:lookupUid" component={SubmitMultiSitePricing} />

								<Route exact path="/public/privacyPolicy" component={PrivacyPolicy} />
								<Route exact path="/public/termsOfService" component={TermsOfService} />
								<Route
									exact
									path="/public/carrierConfirmation/:stationDeliveryId/:securityHash"
									component={CarrierConfirmation}
								/>
								<Route
									exact
									path="/public/bulkDeliveryBatch/supplierLoadingNumbers/:bulkDeliveryBatchId/:securityHash"
									component={SubmitSupplierLoadingNumbers}
								/>
								<Route
									exact
									path="/public/bulkDelivery/supplierLoadingNumbers/:bulkDeliveryId/:securityHash"
									component={SubmitSupplierLoadingNumbers}
								/>
								<Route
									exact
									path="/public/bulkDeliveryBatch/carrierConfirmation/:bulkDeliveryBatchId/:securityHash"
									component={BulkCarrierConfirmation}
								/>
								<Route
									exact
									path="/public/bulkDelivery/carrierConfirmation/:bulkDeliveryId/:securityHash"
									component={BulkCarrierConfirmation}
								/>

								<Route
									exact
									path="/public/bulkDeliveryBatch/supplierConfirmation/:bulkDeliveryBatchId/:securityHash"
									component={BulkSupplierConfirmation}
								/>
								<Route
									exact
									path="/public/bulkDelivery/supplierConfirmation/:bulkDeliveryId/:securityHash"
									component={BulkSupplierConfirmation}
								/>
								<Route component={NoMatch} />
							</Switch>
						</main>
					</div>
				</div>

				<ErrorDialog
					onClose={this.props.clearError}
					errorMessages={errorMessages}
					open={isErrorDialogOpen}
				/>

				<SuccessDialog
					onClose={this.handleSuccessClose}
					successMessages={successMessages}
					open={isSuccessDialogOpen}
				/>
			</div>
		);
	}
}

Layout.propTypes = {
	classes: PropTypes.object.isRequired,
	onSuccessRedirectTo: PropTypes.string,
	successMessages: PropTypes.array,
	errorMessages: PropTypes.array,
	clearError: PropTypes.func,
	clearSuccess: PropTypes.func,
	history: PropTypes.object,
	//authUser : PropTypes.object,
};

export default _.flow([withStyles(styles), LayoutContainer])(Layout);
